@if (userSkinParameters().length) {
<section class="tw-font-lexend tw-mx-4 tw-mt-6 tw-mb-4 tw-px-4 tw-pt-6 tw-pb-2 tw-bg-white tw-rounded-2xl">
  <h2 class="tw-text-gray-800 tw-text-300 tw-font-bold tw-uppercase tw-mb-4">
    @if (isHairReport()) {
      <span i18n="@@reportKeyHairParametersTitle">Your key hair parameters</span>
    } @else {
      <span i18n="@@reportKeySkinParametersTitle">Your key skin parameters</span>
    }
  </h2>
  <div class="tw-flex tw-justify-end tw-relative">
    <p class="tw-absolute tw-top-0 tw-text-gray-400 tw-font-normal tw-uppercase tw-text-100 tw-leading-[11px]" i18n="@@reportParameterTargetLabel">Target</p>
  </div>
  <div>
    @for (item of userSkinParameters(); track item.key) {
      <div>
        <div class="tw-flex tw-items-baseline tw-gap-2">
          <p class="tw-text-gray-800 tw-font-normal tw-text-300 tw-leading-[24px]">
            @switch (item.key) {
              @case (skinParameterKeys.SEBUM_BALANCE) {
                <span>Sebum balance</span>
              }
              @case (skinParameterKeys.INFLAMMATION) {
                <span>Redness</span>
              }
              @case (skinParameterKeys.SENSITIVITY) {
                <span>Sensitivity</span>
              }
              @case (skinParameterKeys.SKIN_RENEWAL) {
                <span>Skin Renewal</span>
              }
              @case (skinParameterKeys.SKIN_RADIANCE) {
                <span>Skin Radiance</span>
              }
              @case (skinParameterKeys.SKIN_DAMAGE) {
                <span>Skin Damage</span>
              }
              @case (hairParameterKeys.HAIR_DENSITY) {
                <span i18n="@@reportHairDensityLabel">Hair Density</span>
              }
              @case (hairParameterKeys.HAIR_STRENGTH) {
                <span i18n="@@reportHairStrengthLabel">Hair Strength</span>
              }
              @case (hairParameterKeys.SCALP_OIL_BALANCE) {
                <span i18n="@@reportScalpOilBalanceLabel">Scalp Oil Balance</span>
              }
              @case (hairParameterKeys.HAIR_SMOOTHNESS) {
                <span i18n="@@reportHairSmoothnessLabel">Hair Smoothness</span>
              }
              @case (hairParameterKeys.PREMATURE_GREYING) {
                <span i18n="@@reportPrematureGreyingLabel">Premature Greying</span>
              }
              @case (hairParameterKeys.GREYING) {
                <span i18n="@@reportGreyingLabel">Greying</span>
              }
            }
          </p>
          @if (item.severity) {
            <span class="tw-text-orange-400 tw-font-normal tw-text-50 tw-leading-[24px] tw-tracking-[1px]">
              @if (item.severity === severityLevels.HIGH) {
                <span i18n="@@reportParameterHighLabel">HIGH</span>
              } @else {
                <span i18n="@@reportParameterLowLabel">LOW</span>
              }
            </span>
          }
        </div>
        <div class="tw-grid tw-grid-cols-[minmax(0,1fr)_auto] tw-items-center tw-gap-x-4">
          <div class="tw-h-2 tw-rounded-full"
               [class]="item.isInRange ? 'tw-bg-[#DCE5C4]' : 'tw-bg-[#F2E4D9]'">
            <div class="tw-h-full tw-rounded-full"
                 [style.width.%]="item.scorePercentage"
                 [class]="item.isInRange ? 'tw-bg-green-400' : 'tw-bg-orange-400'">
            </div>
          </div>
          <div class="tw-relative tw-flex tw-justify-end">
            <span class="tw-inline-block tw-h-0 tw-overflow-hidden tw-whitespace-nowrap tw-text-gray-800 tw-font-normal tw-text-100 tw-leading-[24px]">
              {{ item.targetRange }}
            </span>
            <p class="tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-whitespace-nowrap tw-text-gray-800 tw-font-normal tw-text-100 tw-leading-[24px]">
              {{ item.targetRange }}
            </p>
          </div>
          <div class="tw-leading-none tw-mt-1">
            <div class="tw-block tw-w-fit -tw-translate-x-1/2"
                 [style.margin-left.%]="getBubbleLeftPosition(item.scorePercentage)">
              <div class="tw-relative tw-px-1 tw-rounded-1 tw-text-white tw-font-semibold tw-text-100 tw-leading-[15px] tw-text-center"
                   [class]="item.isInRange ? 'tw-bg-green-400' : 'tw-bg-orange-400'">
                {{ item.patientScore }}
                <div class="tw-absolute -tw-top-[3px] tw-left-1/2 -tw-translate-x-1/2 tw-w-[4px] tw-h-[3px] tw-overflow-hidden">
                  <div class="tw-w-0 tw-h-0 tw-border-l-[2px] tw-border-r-[2px] tw-border-b-[3px] tw-border-l-transparent tw-border-r-transparent"
                       [class]="item.isInRange ? 'tw-border-b-green-400' : 'tw-border-b-orange-400'">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</section>
}
